import { api } from "./api";
import { trackInitiateCheckout } from "./pixel";
import { gaBeginCheckout } from "./ga";

// Single entry point for every buy CTA. Provider comes from /api/pricing (market.provider):
// - monetizze: redirect to the existing global Monetizze URL (unchanged behaviour)
// - stripe: ask the backend for a hosted Stripe Checkout session (international markets only)
export const utmParams = () => { const p = new URLSearchParams(window.location.search); const o = {}; ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((k) => { if (p.get(k)) o[k] = p.get(k); }); return o; };
export const deviceInfo = () => ({ device: window.innerWidth < 768 ? "mobile" : window.innerWidth < 1024 ? "tablet" : "desktop", viewport: `${window.innerWidth}x${window.innerHeight}` });
const track = (event, meta) => api.post("/analytics/event", { event, meta }).catch(() => {});

export async function startCheckout({ pricing, market, lang, meta = {}, utm = utmParams(), onSoon, onError }) {
  const current = pricing?.markets?.[market];
  const src = `mc_${market}_${lang}`;
  const full = { ...meta, ...deviceInfo(), provider: current?.provider || "monetizze" };
  if (current?.provider === "stripe") {
    track("checkout_redirect", full);
    trackInitiateCheckout({ value: current?.amount, currency: current?.currency });
    gaBeginCheckout({ value: current?.amount, currency: current?.currency, market, language: lang, source: meta.source, provider: "stripe" });
    try {
      const { data } = await api.post("/stripe/checkout", { market, lang, origin_url: window.location.origin, source: meta.source, src, utm });
      window.location.href = data.checkout_url;
    } catch (e) { track("stripe_checkout_error", { ...full, error: e?.response?.data?.detail || "network" }); if (onError) onError(e); else if (onSoon) onSoon(); }
    return;
  }
  const url = pricing?.checkout?.active ? pricing.checkout.url : "";
  if (!url) { if (onSoon) onSoon(); return; }
  track("checkout_redirect", full);
  trackInitiateCheckout({ value: current?.amount, currency: current?.currency });
  gaBeginCheckout({ value: current?.amount, currency: current?.currency, market, language: lang, source: meta.source, provider: "monetizze" });
  window.location.href = `${url}${url.includes("?") ? "&" : "?"}${new URLSearchParams({ ...utm, lang, market, src })}`;
}
